<template lang='pug'>
  div
    #preloader(v-if="!(loaded===loadCount)" :style="style()")
      .sk-three-bounce
        .sk-bounce-1.sk-child
        .sk-bounce-2.sk-child
        .sk-bounce-3.sk-child
      //img(:src="`img/common/preloader${isIE() ? '_ie': ''}.gif`")
    slot(v-else)
</template>

<script>
  import Vue from 'vue';
  import {ref, watch, computed} from '@vue/composition-api'
  import {local} from '@/base/utils'

  export default {
    name: "preloader",
    props: {
      //base
      loadCount: {type: Number, default: 1},
      loadData: {type: Function, default: (loaded) => {loaded.value=true}},
      localLoad: {type: Boolean, default: false},
      onLoad: {type: Function, default: null},
      //preloader color
      color: {type: String, default: '#337ab7'},
    },

    setup(props,context) {
      const style = () => ({
        '--main-color': props.color,
      });

      const loaded =
        //ref(0);
        ref(local.value && !props.localLoad ? props.loadCount-1 : 0);
      if (!local.value || props.localLoad) props.loadData(loaded);

      watch(loaded,(loaded) => {
        //console.log('loaded', loaded);
        Vue.nextTick(() =>{
          if (loaded===props.loadCount) {
            if (props.onLoad) props.onLoad();
            app.loaded = true;
          }
        });
      });

      window.onload = () => {
        loaded.value++;
      }

      return {style, loaded}
    }
  }
</script>

<style lang='stylus'>
  @import "../base/mixins.styl"
  #preloader
    ownerSize(fixed)
    flex_centered()
    z-index: 1000
    background: #fff;

  $spinkit-size = 10rem
  //$spinkit-spinner-color = #337ab7
  .sk-three-bounce
    $animationDuration = 1.4s
    $delayRange = 0.32s
    width: ($spinkit-size * 2)
    text-align: center
    .sk-child
      width: ($spinkit-size / 2)
      height: ($spinkit-size / 2)
      background-color: #337ab7;
      background-color: var(--main-color)
      border-radius: 100%
      display: inline-block
      animation: sk-three-bounce $animationDuration ease-in-out 0s infinite both
    .sk-bounce-1
      animation-delay: -1*$delayRange
    .sk-bounce-2
      animation-delay: (-1*$delayRange / 2)
  @keyframes sk-three-bounce
    0%, 80%, 100%
      transform: scale(0)
    40%
      transform: scale(1)
  .mobile
    .sk-three-bounce
      width: $spinkit-size
      .sk-child
        width: ($spinkit-size / 4)
        height: ($spinkit-size / 4)
</style>